import TubeChart from './TubeChart'

export default TubeChart


// WEBPACK FOOTER //
// ./src/components/TubeChart/index.js